module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module2-1.1eec97f1.png";